import React from 'react';
import { Icon } from 'antd';

function SelectedOption({ option, onChange, displayExtraDesArea, editingPriceCalculationRule, t }) {
  return (
    <div className="price-calc-display__selected-option">
      <div className="price-calc-display__selected-option__header">
        <label>{t('cms.property.listing_management.price-calc-display.selected')}:</label>
        {onChange && (
          <button onClick={onChange}>
            <Icon type="edit" />
            {t('cms.property.listing_management.price-calc-display.change')}
          </button>
        )}
      </div>

      <div className="price-calc-display__selected-option__content">
        <div className="price-calc-display__selected-option__content__main">
          <div className="price-calc-display__selected-option__content__main__icon">
            {option.icon}
          </div>
          <div>
            <h3>{t(option.label)}</h3>
            <p>{t(option.des)}</p>
          </div>
        </div>

        <SelectedOptionExtraDea
          t={t}
          extraDes={option.extraDes}
          editingPriceCalculationRule={editingPriceCalculationRule}
        />

        {displayExtraDesArea && option.extraDesArea?.length > 0 && (
          <div className="price-calc-display__selected-option__content__extra-area">
            {option.extraDesArea.map(des => (
              <div key={des}>
                <p key={des} dangerouslySetInnerHTML={{ __html: des }}></p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function SelectedOptionExtraDea({ t, extraDes, editingPriceCalculationRule }) {
  if (extraDes?.length === 0) {
    return null;
  }
  const MinimalDesItem = ({ des, showDivider }) => {
    const desResult = typeof des === 'function' ? des({ editingPriceCalculationRule }) : des;
    const isI18nKey =
      typeof desResult === 'string' &&
      (desResult.startsWith('cms.') || desResult.startsWith('cms:'));

    return (
      <>
        <span className="price-calc-display__selected-option__content__extra__item">
          {isI18nKey ? t(desResult) : desResult}
        </span>
        {showDivider && desResult && (
          <i className="price-calc-display__selected-option__content__extra__divider" />
        )}
      </>
    );
  };
  return (
    <div className="price-calc-display__selected-option__content__extra">
      {extraDes.map((des, index) =>
        Array.isArray(des) ? (
          <div
            className="price-calc-display__selected-option__content__extra__nested-container"
            key={`extraDes-${index}`}
          >
            {des.map((nestedDes, nestedDesIndex) => (
              <MinimalDesItem
                key={`nestedDesIndex-${nestedDesIndex}`}
                des={nestedDes}
                showDivider={nestedDesIndex + 1 !== des.length}
              />
            ))}
          </div>
        ) : (
          <div className="price-calc-display__flex-align-center" key={`extraDes-${index}`}>
            <MinimalDesItem des={des} showDivider={index + 1 !== extraDes.length} />
          </div>
        ),
      )}
    </div>
  );
}

function OtherOptions({ options, displayExtraDesArea, t }) {
  return (
    <div className="price-calc-display__other-options">
      <div className="price-calc-display__other-options__header">
        <label>
          {options.length > 1
            ? t('cms.property.listing_management.price-calc-display.other_options')
            : t('cms.property.listing_management.price-calc-display.other_option')}
          :
        </label>
      </div>

      <div className="price-calc-display__other-options__list">
        {options.map(option => (
          <div key={option.label} className="price-calc-display__other-options__content">
            <div className="price-calc-display__other-options__content__main">
              <div className="price-calc-display__other-options__content__main__icon">
                {option.icon}
              </div>
              <div className="price-calc-display__other-options__content__main__text">
                <h3>{t(option.label)}</h3>
                <p>{t(option.des)}</p>
              </div>
            </div>

            {displayExtraDesArea && option.extraDesArea?.length > 0 && (
              <div className="price-calc-display__other-options__content__extra-area">
                {option.extraDesArea.map(des => (
                  <div key={des}>
                    <p key={des} dangerouslySetInnerHTML={{ __html: des }}></p>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const PriceCalcDisplaySelect = {
  SelectedOption,
  OtherOptions,
};

export default PriceCalcDisplaySelect;
